export default __webpack_public_path__ + "static/media/map_icon.3507c4f4.svg";